import { useMemo } from "react";
import { Chart } from "@highcharts/react";
import { useTranslation } from "react-i18next";
import getMetricSpec, { getFormatter } from "../../../merchandising/utils/metrics";
import { HOURS } from "../constants";

const HourChart = ({ data, metrics, initialSelection, size = "lg", marketPlace }) => {
  const { t } = useTranslation(["advertising"]);
  const options = useMemo(() => {
    const series = metrics.map((metric) => {
      const { id, color, name, accessor, chartType = "area", formatter, axis = 0 } = metric;

      let chartData = data?.map((d) => accessor(d) ?? null);
      chartData = chartData?.filter((d) => d)?.length === 0 ? [] : chartData;
      const additionalOptions = {};
      if (chartType === "area") {
        additionalOptions["fillOpacity"] = 0.1;
      }
      if (chartType === "column") {
        additionalOptions["opacity"] = 0.8;
      }
      const visible = initialSelection.includes(id);
      return {
        id,
        custom: { id },
        data: chartData,
        color,
        visible,
        name,
        yAxis: axis,
        type: chartType,
        tooltip: {
          formatter: function () {
            return (
              '<span style="color:' +
              this.series.color +
              '">\u25CF</span> ' +
              this.series.name +
              ": " +
              formatter(this.y) +
              "<br/>"
            );
          },
        },
        ...additionalOptions,
      };
    });
    return {
      title: { text: t(($) => $.advertising["Hourly Trends"]) },
      chart: {
        marginLeft: 90,
        marginRight: 10,
        style: {
          "font-family": "Poppins",
          "font-size": "15px",
        },
        height: size === "lg" ? 460 : 300,
      },
      legend: {
        itemStyle: {
          fontWeight: "bold",
        },
      },
      tooltip: {
        shared: true,
        formatter: function () {
          const points = this.points;

          let markup =
            points.length ?
              '<span style="font-size: 10px; font-weight: bold; margin-left: 1rem">' + points[0].key + "</span><br/>"
            : "";

          for (let index = 0; index < points.length; index++) {
            const point = points[index];

            // Get metric spec and formatter
            const metricId = point?.series?.options?.id;
            const metricSpec = getMetricSpec(metricId);
            const formatter = getFormatter(marketPlace, metricSpec.format, metricSpec);

            markup +=
              '<span style="color:' +
              point.series.color +
              '">\u25CF</span> ' +
              point.series.name +
              ": " +
              formatter(point.y) +
              "<br/>";
          }

          return markup;
        },
      },
      yAxis: Array.from(Array(50)).map(() => ({
        title: {
          text: "",
        },
        visible: false,
        maxPadding: 0,
      })),
      xAxis: {
        categories: HOURS.map((hour) => t(hour)),
      },
      series,
    };
  }, [data, metrics, initialSelection, size, marketPlace, t]);
  return <Chart options={options} />;
};

export { HourChart };
